// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/******************************
*  Shadows Tokens
******************************/
:root {
  --m-box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, .03);
  --m-dropdown-shadow: 0 8px 10px rgba(9, 30, 66, 0.15), 0 0 1px rgba(9, 30, 66, 0.2);
  --m-box-shadow-card: 0 0.75rem 1.5rem rgba(18,38,63,.03);
  --m-header-box-shadow: 0px 0px 35px 0px rgba(154, 161, 171, 0.15);
}

[m-data-theme=dark] {
  --m-box-shadow: 0 0.75rem 1.5rem transparent;
  --m-dropdown-shadow: 0 8px 10px transparent, 0 0 1px transparent;
  --m-box-shadow-card: 0 0.75rem 1.5rem transparent;
  --m-header-box-shadow: 0px 0px 35px 0px transparent;
}`, "",{"version":3,"sources":["webpack://./src/styles/tokens/_shadows.scss"],"names":[],"mappings":"AAAA;;8BAAA;AAGA;EACI,sDAAA;EACA,mFAAA;EACA,wDAAA;EACA,iEAAA;AACJ;;AAEA;EACI,4CAAA;EACA,gEAAA;EACA,iDAAA;EACA,mDAAA;AACJ","sourcesContent":["/******************************\n*  Shadows Tokens\n******************************/\n:root {\n    --m-box-shadow: 0 0.75rem 1.5rem rgba(18, 38, 63, .03);\n    --m-dropdown-shadow: 0 8px 10px rgba(9, 30, 66, 0.15), 0 0 1px rgba(9, 30, 66, 0.2);\n    --m-box-shadow-card: 0 0.75rem 1.5rem rgba(18,38,63,.03);\n    --m-header-box-shadow: 0px 0px 35px 0px rgba(154, 161, 171, 0.15);\n}\n\n[m-data-theme='dark'] {\n    --m-box-shadow: 0 0.75rem 1.5rem transparent;\n    --m-dropdown-shadow: 0 8px 10px transparent, 0 0 1px transparent;\n    --m-box-shadow-card: 0 0.75rem 1.5rem transparent;\n    --m-header-box-shadow: 0px 0px 35px 0px transparent;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
